import React, { useEffect, useState } from 'react'
import { Link, Outlet } from 'react-router-dom'

export default function Shop() {
  
  return (  
      <Outlet/>
  )
}
